import React, { useEffect, useState } from 'react'
import './normal-notice-detail.less'
import { setHeader } from '@/util/set-header'
import { List, Toast } from 'antd-mobile'
import { setreadNoticeApi, noticedetailApi } from '@/api/user-infomation'
const Item = List.Item
const Brief = Item.Brief
function NormalNoticeDetail({ history, match }: any) {
  const { id } = match.params
  const formType = match.params.type
  const [data, setData]: any = useState()
  useEffect(() => {
    const leftClick = () => {
      if (history.length > 1) {
        history.goBack()
      } else {
        if (window.WebViewBridge) {
          window.WebViewBridge.navBackMarket()
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      }
    }
    setHeader({ title: '通知详情', leftClick })

    const fetchNoticedetail = async () => {
      Toast.loading('加载中', 0)
      const url =
        formType === 'list'
          ? `/mall/notice/app/detail.json`
          : `/mall/notice/push/detail.json`
      const { data } = await noticedetailApi(url, { id })
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 3)
        return false
      }
      const { app_notice_id } = data.data
      setData(data.data)
      //设置消息已阅读
      setreadNoticeApi({ id: app_notice_id })
    }
    //获取消息详情
    fetchNoticedetail()
  }, [id, formType, history])
  return (
    <div className="normal-notice-detail">
      <List>
        <Item
          extra={<span className="font-8">{data?.add_time}</span>}
          align="bottom"
          multipleLine
        >
          {data?.title}{' '}
          <Brief>
            <span className="font-8">{data?.author}</span>{' '}
          </Brief>
        </Item>
        <Item data-seed="logId" wrap>
          <div dangerouslySetInnerHTML={{ __html: data?.text }} />
        </Item>
      </List>
    </div>
  )
}

export default NormalNoticeDetail
